import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Constant } from '@app/@core';
import { StudyAccessType } from '@app/@shared/enums';
import { SpinnerService } from '@app/@shared/spinner/spinner.service';
import { StudyModel } from '@app/interface';
import { ActiveStatus } from '@app/interface/common';
import { UserGroupModel } from '@app/interface/userGroup.model';
import { UserService, SurveyService, StudiesService, UserGroupService } from '@app/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as firebase from 'firebase';
import { ProviderDataValidators as Validators } from '@app/modules/data-valiidator';

@Component({
  selector: 'app-add-access',
  templateUrl: './add-access.component.html',
  styleUrls: ['./add-access.component.scss'],
})
export class AddAccessComponent implements OnInit {
  accessForm: FormGroup;
  submitted = false;
  success: boolean;
  date = new Date().toISOString();
  isLoading = false;
  // surveyStatus: ActiveStatus[] = Constant.ActiveStatus;
  @Input() title_tag: string;
  @Input() formType: string;
  @Input() form_data: any;
  studyDetail: StudyModel;
  userGroupsOptins: Array<UserGroupModel> = [];
  userGroups: Array<UserGroupModel> = [];

  constructor(
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    public userService: UserService,
    private surveyService: SurveyService,
    private studiesService: StudiesService,
    private userGroupServie: UserGroupService
  ) {}

  ngOnInit() {
    this.createForm();
    // this.getstudyDetail();
    // this.getUserGroups();
  }

  // private getstudyDetail(studyName?: string): void {
  //   this.studiesService.getStudyDetailById().subscribe((study: StudyModel) => {
  //     this.studyDetail = study;
  //     if (this.studyDetail?.studyAccessType === StudyAccessType.DEFAULT) {
  //       this.accessForm.get('groupIds').clearValidators();
  //       this.accessForm.get('groupIds').updateValueAndValidity();
  //     }
  //   });
  // }

  private createForm(): void {
    this.accessForm = this.formBuilder.group({
      email: ['', [Validators.required()]],
      role: ['', [Validators.required()]],
      studyId: [localStorage.getItem('studyId'), [Validators.required]],
    });
    if (this.formType === 'Edit') {
      this.accessForm.patchValue(this.form_data);
    }
  }

  get formControl() {
    return this.accessForm.controls;
  }

  public save(): void {
    this.submitted = true;
    if (this.accessForm.valid) {
      const accessData = this.accessForm.value;
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateAccess(accessData);
      } else {
        this.submitAddEditAccess(accessData);
      }
    } else {
      return;
    }
  }

  private submitAddEditAccess(accessData: any): void {
    this.userService.addAdminRoles(accessData).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  private updateAccess(accessData: any): void {
    this.userService.updateAdminRole(accessData).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  // private getRupteParmas(): void {
  //   this.studiesService.routeParams$.subscribe((params) => {
  //     if (params) {
  //       this.getstudyDetail(params.name);
  //     }
  //   });
  // }

  // private getUserGroups(): void {
  //   this.userGroupServie.getUserGroups().subscribe((userGroups: UserGroupModel[]) => {
  //     this.userGroupsOptins = userGroups;
  //     this.checkGroupIds();
  //   });
  // }

  private getDefaultStudyGroup(): void {
    this.userGroupServie.getDefaultStudyGroup().subscribe((defaultGroup: UserGroupModel) => {});
  }

  // private checkGroupIds(): void {
  //   let studyId = this.studiesService.getStudyId();
  //   let groupIds = this.accessForm.get('groupIds').value;
  //   if (groupIds && groupIds.length === 0) {
  //     let defaultGroup = this.userGroupsOptins.find((item) => item.studyId === studyId && item.isDefault === true);

  //     this.accessForm.get('groupIds').patchValue([defaultGroup.uuid]);
  //   }
  // }
}
